module.exports = __webpack_public_path__ + "media/images/header__bg-48e4f159bb7da68cae2cafcab79b5af4.jpg";